import { Mic, ArrowUp } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from '@/i18n'
import { useAppStore } from '@/store'
import { IntuiTooltip } from '@/components/intueri/IntuiTooltip'

/**
 * Message composer: autosizing-ish textarea (Enter = send, Shift+Enter =
 * newline), a disabled mic (voice input deferred — the existing ChatVoice
 * capture path submits through the MAIN chat's send button by DOM id and
 * isn't safely reusable here yet), and the round brand send button.
 */
const HelpAgentInput = () => {
  const { t } = useTranslation('help_agent')
  const location = useLocation()
  const helpInputValue = useAppStore((s) => s.helpInputValue)
  const setHelpInputValue = useAppStore((s) => s.setHelpInputValue)
  const helpIsStreaming = useAppStore((s) => s.helpIsStreaming)
  const sendHelpMessage = useAppStore((s) => s.sendHelpMessage)

  const canSend = helpInputValue.trim() !== '' && !helpIsStreaming

  const submit = () => {
    if (!canSend) return
    void sendHelpMessage(helpInputValue.trim(), location.pathname)
  }

  return (
    <div className="border-t border-gray-100 p-3 dark:border-dark-border">
      <div className="flex flex-col gap-1 rounded-xl border border-gray-200 bg-white px-3 py-2 focus-within:ring-1 focus-within:ring-ring dark:border-dark-border dark:bg-dark-card">
        <textarea
          rows={2}
          value={helpInputValue}
          placeholder={t('input.placeholder')}
          onChange={(event) => setHelpInputValue(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && !event.shiftKey) {
              event.preventDefault()
              submit()
            }
          }}
          className="max-h-28 w-full resize-none bg-transparent text-sm text-gray-900 outline-none placeholder:text-muted-foreground dark:text-dark-text"
        />
        <div className="flex items-center justify-end gap-1.5">
          <IntuiTooltip content={t('input.mic_unavailable')}>
            <span>
              <button
                type="button"
                disabled
                aria-label={t('input.mic_unavailable')}
                className="flex size-8 items-center justify-center rounded-full text-muted-foreground opacity-50"
              >
                <Mic className="size-4" />
              </button>
            </span>
          </IntuiTooltip>
          <button
            type="button"
            aria-label={t('input.send')}
            disabled={!canSend}
            onClick={submit}
            className="flex size-8 items-center justify-center rounded-full bg-brand text-white transition-colors hover:bg-brand-hover disabled:opacity-40"
          >
            <ArrowUp className="size-4" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default HelpAgentInput
